import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import {Request, RequestsMixin, GET} from 'requests';
import Feature from 'components/Feature';
import IconsSummary from './IconsSummary';
import TypefacesSummary from './TypefacesSummary';
import ImagesSummary from './ImagesSummary';
import KitMessages from './KitMessages';

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const SummaryController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  componentWillMount() {
    this.setRequest({
      kitMessages: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'messages'],
      }),
    });
  },

  renderKitMessages(kitMessages) {
    let kitMessageElement = null;

    if (!kitMessages.isEmpty()) {
      kitMessageElement = (
        <div className="col-xs-3">
          <KitMessages kitToken={this.props.kitToken} messages={kitMessages} />
        </div>
      );
    }

    return kitMessageElement;
  },

  render() {
    const {kitToken} = this.props;
    const {
      kitMessages: kitMessagesRequest,
    } = this.requests;

    const rm = this.resourceManager();
    const kitMessages = rm.type(kitMessagesRequest, 'kit-messages').all();
    const hasKitMessages = !kitMessages.isEmpty();
    const summaryProps = {kitToken}

    return (
      <div className="row m-xs-t-md">
        <div className={hasKitMessages ? 'col-xs-9' : 'col-xs-12'}>
          <IconsSummary {...summaryProps} />
          <TypefacesSummary {...summaryProps} />
          <Feature name="images">
            <ImagesSummary {...summaryProps} />
          </Feature>
        </div>
        {this.renderKitMessages(kitMessages)}
      </div>
    );
  },
});

export default connect(mapStateToProps)(SummaryController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/SummaryController.js